import { useAuth } from '../../hooks/useAuth'
import { Navigate, useLocation } from 'react-router-dom'
import { Loader2 } from 'lucide-react'

interface ProtectedRouteProps {
  children: React.ReactNode
  /**
   * @deprecated Subscription entitlement no longer gates route entry.
   * Workspace routes handle read-only behavior at the feature level.
   */
  requireSubscription?: boolean
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation()
  const { user, loading: authLoading } = useAuth()

  // Show loading while checking auth
  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    )
  }

  // Redirect to sign in if not authenticated
  if (!user) {
    return <Navigate to="/signup" replace state={{ from: location }} />
  }

  return <>{children}</>
}
